module.exports = __webpack_public_path__ + "img/update-item-task.a6fde01b.svg";